@if (crmBannerPromotions.length) {
    <ms-crm-promotion-container [promotions]="crmBannerPromotions" />
}
<ms-meeting [races]="vm.races" (fixtureClick)="onFixtureClick($event)" />
